import { WifiOff, RefreshCw } from 'lucide-react';

export function OfflinePage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="max-w-sm text-center space-y-6">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-muted mx-auto">
          <WifiOff className="h-10 w-10 text-muted-foreground" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-foreground">You're Offline</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Please check your internet connection and try again.
          </p>
        </div>
        <button
          onClick={() => window.location.reload()}
          className="inline-flex items-center gap-2 rounded-lg bg-primary px-6 py-2.5 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
        >
          <RefreshCw className="h-4 w-4" />
          Retry
        </button>
      </div>
    </div>
  );
}
